<template>
    <div class="title">
        <div class="txt" :style="{color:color}">{{title}}</div>
        <div class="segmentation" :style="{color:color}">——</div>
        <div class="description" :style="{color:color}">{{description}}</div>
    </div>
</template>
<script>
export default {
    props:['title','description','color']
}
</script>
<style lang="less" scoped>
    .title{
        text-align: center;
        margin-bottom: 30px;
        .txt{
            color: rgb(51, 51, 51);
            font-size: 36px;
            font-weight: bold;
        }
        .segmentation{
            text-align: center;
            color: rgb(13, 94, 204);
        }
        .description{
            font-size: 16px;
            color: rgb(102, 102, 102);
        }
    }
</style>